export const BILLS_TABS_OPTIONS = {
  UNPAID: 'Unpaid',
  PAID: 'Paid',
}as const;

export const BILLS_TABS_OPTIONS_TEXTS = {
  UNPAID: 'BILL_PAY.BILLS_HUB.TABS.UNPAID',
  PAID: 'BILL_PAY.BILLS_HUB.TABS.PAID',
}as const;

export const BILLS_TABLE_NAMES_TITLES = {
  UNPAID: 'BILL_PAY.BILLS_HUB.TABLE_NAMES.UNPAID',
  PAID: 'BILL_PAY.BILLS_HUB.TABLE_NAMES.PAID',
} as const;

export const BILLS_TABLE_OPTIONS = {
  UNPAID: 'Outstanding',
  PAID: 'Paid',
};
